export interface IDomainFormDTO {
  name: string,
  productId: number,
  emailEnabled?: boolean,
  openAppLinkAndroid?: string,
  openAppLinkIos?: string,
  externalRef?: string,
  startDate?: string,
};

export interface ICustomerDomainFormDTO {
  id?: number;
  name: string;
  customerId: number;
  hostname: string;
  lockbaseId: string;
  type: string;
  solution: string;
  platform: string;
  management: string;
  modality: string;
  subSegment: string;
  zenDeskId: string;
  loginData: string;
  license1ris: string;
};

export interface IDomainInDTO {
  id?: number;
  appId: number;
  companyId: number;
  hostname: string;
  installationMode: boolean;
  name: string;
  serviceName: string;
  subscriptionDomainHostname?: string;
  subscriptionDomainCompanyId?: number;
  createdAt?: number;
  deleted?: boolean;
  cloudCredits?: boolean;
  enable1ris?: string;
  walletId?: number;
  customerId?: number;
  solution?: string;
  management?: string;
  modality?: string;
  subSegment?: string;
  segmentType?: string;
  license1ris?: string;
  loginData?: string;
  zenDeskId?: string;
  lockbaseId?: string;
  type?: string;
  platform?: string;
}

export enum DomainIrisStatusOptions {
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
  ENABLED = 'ENABLED',
}